/**
 * Pending Document Banner
 * 미제출 서류 상단 배너 (건너뛰기 후 필수/선택 모두 포함)
 */

import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FileUp, X } from "lucide-react";
import { useState } from "react";
import requiredDocumentService from "@/services/requiredDocumentService";

export default function PendingDocumentBanner() {
  const [dismissed, setDismissed] = useState(false);

  const { data: submissions = [] } = useQuery({
    queryKey: ["my-pending-documents-banner"],
    queryFn: requiredDocumentService.getMyPending,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });

  // 필수/선택 구분 없이 전체 미제출(pending) + 반려(rejected) 건수
  const pendingDocs = submissions.filter(
    (s) => s.status === "pending" || s.status === "rejected"
  );

  if (dismissed || pendingDocs.length === 0) {
    return null;
  }

  return (
    <div className="bg-blue-50 border-b border-blue-200 px-4 py-2">
      <div className="flex items-center justify-between max-w-screen-xl mx-auto">
        <div className="flex items-center gap-2 text-sm text-blue-700">
          <FileUp className="w-4 h-4 shrink-0" />
          <span>
            미제출 서류가 <strong>{pendingDocs.length}건</strong> 있습니다.
          </span>
          <Link
            to="/document-submission"
            className="underline font-medium hover:text-blue-900"
          >
            제출하기
          </Link>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-blue-400 hover:text-blue-600 p-1"
          aria-label="배너 닫기"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
